
import { defineComponent } from 'vue';

export default defineComponent({
  props: ['arealist', 'loading'],
  setup() {
    const pane_height = document.body.clientHeight - 390
    return {
      pane_height
    }
  }
})
